@let currentLabel = label();
@let currentDescription = description();

<div class="mb-4">
  <div class="flex items-center gap-3">
    <div
      class="relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
      [ngClass]="{
        'bg-primary': value,
        'bg-gray-200': !value,
        'opacity-50 cursor-not-allowed': isDisabled,
      }"
      (click)="toggle()"
      [attr.aria-checked]="value"
      role="switch"
      tabindex="0"
      (keydown.space)="$event.preventDefault(); toggle()"
      (keydown.enter)="$event.preventDefault(); toggle()"
      (blur)="onTouched()"
    >
      <span
        aria-hidden="true"
        class="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
        [ngClass]="{ 'translate-x-5': value, 'translate-x-0': !value }"
      ></span>
    </div>
    <div>
      @if (currentLabel) {
        <label
          [for]="effectiveName()"
          class="text-[12px] font-bold cursor-pointer"
          (click)="toggle()"
        >
          {{ currentLabel }}
        </label>
      }
      @if (currentDescription) {
        <div class="text-[12px] cursor-pointer" (click)="toggle()">
          {{ currentDescription }}
        </div>
      }
    </div>
  </div>

  @if (displayError()) {
    <lib-custom-error-display [errors]="errors()" [control]="ngControl"></lib-custom-error-display>
  }
</div>
